export function removeParamsFromUrl(url: string, paramsToDelete: string[]) {
  const [path, params] = url.split('?');

  const query = new URLSearchParams(params);
  for (const param of paramsToDelete) {
    query.delete(param);
  }

  return `${path}${query.size ? `?${query.toString()}` : ''}`;
}
